<template>
    <!-- eslint-disable vue/no-v-html -->
    <div id="tdescr" class="cabinet-detail-table">
        <div
            v-if="description"
            class="cabinet-detail-table__row"
            v-html="description"
        />
        <div v-else class="cabinet-detail-table__row">
            Описание отсутствует
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductDescription',
    props: {
        description: {
            type: String,
            default: ''
        }
    }
}
</script>
